import { useTranslation } from 'react-i18next';
import ChatStyles from "./Chat.module.css";

const ChatboxPlaceholder = ({ hasConnections, onNewChat }) => {
	const { t } = useTranslation();

	if (!hasConnections) {
		// ── Variant A: No connections yet ─────────────────────────
		return (
			<div className={ChatStyles.welcomeWrap}>
				<div className={ChatStyles.welcomeIcon}>
					<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
						<rect x="3" y="11" width="18" height="11" rx="2" />
						<path d="M7 11V7a5 5 0 0 1 10 0v4" />
					</svg>
				</div>
				<div className={ChatStyles.welcomeTitle}>{t('screens.chat.welcomeTitle')}</div>
				<div className={ChatStyles.welcomeSub}>
					{t('screens.chat.welcomeSub')}
				</div>
				<div className={ChatStyles.welcomeCards}>
					<div className={ChatStyles.welcomeCard}>
						<div className={`${ChatStyles.welcomeCardIcon} ${ChatStyles.welcomeCardIconBurg}`}>
							<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#800020" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
								<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
							</svg>
						</div>
						<div className={ChatStyles.welcomeCardTitle}>{t('screens.chat.cardE2ETitle')}</div>
						<div className={ChatStyles.welcomeCardDesc}>{t('screens.chat.cardE2EDesc')}</div>
					</div>
					<div className={ChatStyles.welcomeCard}>
						<div className={`${ChatStyles.welcomeCardIcon} ${ChatStyles.welcomeCardIconPurple}`}>
							<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
								<polygon points="23 7 16 12 23 17 23 7" />
								<rect x="1" y="5" width="15" height="14" rx="2" />
							</svg>
						</div>
						<div className={ChatStyles.welcomeCardTitle}>{t('screens.chat.cardVideoTitle')}</div>
						<div className={ChatStyles.welcomeCardDesc}>{t('screens.chat.cardVideoDesc')}</div>
					</div>
					<div className={ChatStyles.welcomeCard}>
						<div className={`${ChatStyles.welcomeCardIcon} ${ChatStyles.welcomeCardIconGreen}`}>
							<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
								<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
								<polyline points="14 2 14 8 20 8" />
							</svg>
						</div>
						<div className={ChatStyles.welcomeCardTitle}>{t('screens.chat.cardFilesTitle')}</div>
						<div className={ChatStyles.welcomeCardDesc}>{t('screens.chat.cardFilesDesc')}</div>
					</div>
				</div>
				<button className={ChatStyles.welcomeCta} onClick={onNewChat}>
					{t('screens.chat.welcomeCta')}
				</button>
				<div className={ChatStyles.welcomeEncNote}>
					<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2">
						<rect x="3" y="11" width="18" height="11" rx="2" />
						<path d="M7 11V7a5 5 0 0 1 10 0v4" />
					</svg>
					{t('screens.chat.encryptedNote')}
				</div>
			</div>
		);
	}

	// ── Variant B: Has connections, none selected ──────────────
	return (
		<div className={ChatStyles.selectWrap}>
			<div className={ChatStyles.selectIconBg}>
				<div className={ChatStyles.selectIconCircle}>
					<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
						<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
					</svg>
				</div>
				<div className={ChatStyles.selectOnlineDot} />
			</div>
			<div className={ChatStyles.selectTitle}>{t('screens.chat.selectConvTitle')}</div>
			<div className={ChatStyles.selectSub}>
				{t('screens.chat.selectConvSub')}
			</div>
			<div className={ChatStyles.welcomeEncNote} style={{ marginTop: 18 }}>
				<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2">
					<rect x="3" y="11" width="18" height="11" rx="2" />
					<path d="M7 11V7a5 5 0 0 1 10 0v4" />
				</svg>
				{t('screens.chat.encryptedNote')}
			</div>
		</div>
	);
};

export default ChatboxPlaceholder;
